import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { LocationData, LocationOptions } from '../location-picker/location-picker.component';
import { MainService } from '../../services/optimizer-service/optimizer.service';
import { MapControls } from '../../utilities/MapControls/MapConrols';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FormUtils } from '../../utilities/FormUtils/FormUtils';
import * as moment from 'moment';
declare var google: any;
declare var $: any;
@Component({
  selector: 'app-add-stops-dialog',
  templateUrl: './add-stops-dialog.component.html',
  styleUrls: ['./add-stops-dialog.component.css']
})
export class AddStopsDialogComponent implements OnInit, AfterViewInit {


  prefill: PrefillData = null;
  form: FormGroup;
  constructor(private mapControls: MapControls, public dialogRef: MatDialogRef<AddStopsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private main: MainService) {
    this.prefill = data.prefill;
    this.form = new FormGroup({
      time: new FormControl('ASAP', [Validators.required]),
      deliveryTime: new FormControl(moment().toDate(), [Validators.required]),
      address: new FormControl(null, [Validators.required]),
      lat: new FormControl(null, [Validators.required]),
      lng: new FormControl(null, [Validators.required]),
      name: new FormControl(null, [Validators.required]),
      phone: new FormControl(null, [Validators.required]),
      comments: new FormControl(null, [])
    })
    if (this.prefill) {
      this.form.patchValue(this.prefill);
      if (this.prefill.time == 'SCHEDULE') {
        this.initTimePicker();
      }
    }
  }

  ngOnInit() {


  }

  ngAfterViewInit(): void {


      this.initAuto('recipientaddress', (data) => {
        var searchInput: any = document.getElementById('recipientaddress');
        this.form.patchValue({
          address: searchInput.value,
          lat: data.place.geometry.location.lat(),
          lng: data.place.geometry.location.lng()
        })
      });


  }

  initAuto(id, callback) {
    var input = document.getElementById(id);
    var auto = new google.maps.places.Autocomplete(input, this.getOptions());
    this.registerPickup(id, auto, callback);
    input.addEventListener('focus', () => {
      const pacContainer = document.querySelector('.pac-container') as HTMLElement;
      if (pacContainer) {
        const rect = input.getBoundingClientRect();
        pacContainer.style.top = `${rect.bottom + window.scrollY}px`;
        pacContainer.style.left = `${rect.left + window.scrollX}px`;
        pacContainer.style.width = `${rect.width}px`;
      }
    });
  }

  registerPickup(id, input, callback) {
    this.mapControls.registerAutcompleteListener('place_changed', input).then(place => {
      callback({
        id: id,
        place: place
      });
      this.registerPickup(id,input,callback)
    }).catch(e => {

    })
  }

  getOptions() {
    var defaultBounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(17.546889258900055, -78.54058735825066),
      new google.maps.LatLng(18.591323377300697, -76.02471821762566)
    )
    return {
      appendTo:'body',
      bounds: defaultBounds
    };
  }


  getClass(name) {
    if (this.isFieldInvalid(name)) {
      return 'form-control round-input error-border';
    } else {
      return 'form-control round-input';
    }
  }

  onScheduleChange(event) {
    if (this.form.get('time').value == 'SCHEDULE') {
      this.initTimePicker();
    }
  }


  initTimePicker() {
    $(document).ready(() => {
      var startDate = moment();
      if (this.prefill) {
        if (this.prefill.deliveryTime) {
          startDate = moment(this.prefill.deliveryTime);
        }
      }
      $('#pickuptimeinput').daterangepicker({
        startDate: startDate,
        singleDatePicker: true,
        drops: 'up',
        timePicker: true,
        locale: {
          format: 'DD, MMM YYYY hh:mm A'
        },
      }, (sD: moment.Moment, label) => {
        this.form.patchValue({
          deliveryTime: sD.toDate()
        })
      });
    })
  }

  // Helper method to check if a field is invalid
  isFieldInvalid(name: string): boolean {
    var field = this.form.get(name);
    if(name == 'address'){
      if ((field.invalid && field.touched) || ( field.touched && (this.form.get('lat').invalid || this.form.get('lng').invalid) )) {
        return true;
      }
    }
    if (field.invalid && field.touched) {
      return true;
    }
    return false;
  }

  add() {
    FormUtils.markFormGroupTouched(this.form);
    if (this.form.valid) {
      var payload = this.form.getRawValue();
      var searchInput: any = document.getElementById('recipientaddress');
      payload.address = searchInput.value;
      this.dialogRef.close(payload);
    }
  }

  close() {
    this.dialogRef.close();
  }


}

export interface PrefillData {
  time: string,
  deliveryTime: any,
  address: string,
  lat: any,
  lng: any,
  name: any,
  phone: any,
  comments: any
}


// WEBPACK FOOTER //
// ./src/app/shared/add-stops-dialog/add-stops-dialog.component.ts